import Vue from "vue";

export default {
    ROOM_FILE_INIT: function(state, data=[]) {
        state.roomFileList = data;
    },
    // updateFileList: function(state, data=[]) {
    //     state.roomFileList = data;
    // },
    DELETE_ROOM_FILE: function(state, {roomFileId}) {
        let idx = state.roomFileList.findIndex(el => el.roomFileId == roomFileId);
        if(idx < 0)
            return;
        state.roomFileList[idx].del = true;
        state.roomFileList.splice(idx, 1);
        
    },
    REMOVE_UPLOAD_ROOM_FILE: function(state, {reqId}){
        let idx = state.uploadRoomFileList.findIndex(el => el.reqId == reqId);
        if(idx > -1)
            state.uploadRoomFileList.splice(idx, 1);
    },
    ADD_ROOM_FILE: function(state, { roomFile}){
        let idx = state.uploadRoomFileList.findIndex(el => el.roomFileId == roomFile.roomFileId);
        if(idx > -1)
            state.uploadRoomFileList.splice(idx, 1);
        
        state.roomFileList.push(roomFile);
    },
    UPLOAD_ROOM_FILE: function(state, uploadObj){
        state.uploadRoomFileList.push(uploadObj);
    },
    CHANGE_UPLOAD_ROOM_FILE: function(state, changeInfo){
        let obj = state.uploadRoomFileList.find(u => u.reqId == changeInfo.reqId);
        if(!obj){
            console.warn('upload obj is null', changeInfo);
            return;
        }
        Object.assign(obj, changeInfo);
        let progress = Math.min(
                        Math.round(obj.loaded * 100 / obj.size)
                        ,100
                    );
        if(isNaN(progress)){
            console.warn('calc progress :', obj.loaded, obj.size);
        }else{
            obj.progress = progress;
        }
    },
    UPDATE_FILE_DOWNLOAD_PROGRESS: function(state, data={}){
        let {roomFile, progress, downloadState} = data;
        let idx = state.roomFileList.findIndex(el => el.roomFileId == roomFile.roomFileId);
        
        if(progress){
            if(!state.roomFileList[idx].progress) {
                Vue.set(state.roomFileList[idx], 'progress');
            }
            state.roomFileList[idx].progress = progress;
        }

        if(downloadState){
            if(!state.roomFileList[idx].downloadState) {
                Vue.set(state.roomFileList[idx], 'downloadState');
            }
            state.roomFileList[idx].downloadState = downloadState;
        }
    },
}
